type PhotonBriefSection = "atlas" | "library" | "reviews" | "method" | "";

type PhotonBriefHeaderProps = {
  active: PhotonBriefSection;
};

const items: Array<{
  key: Exclude<PhotonBriefSection, "">;
  href: string;
  label: string;
  helper: string;
}> = [
  { key: "atlas", href: "/", label: "Atlas", helper: "Research map" },
  { key: "library", href: "/library/", label: "文献库", helper: "Library" },
  { key: "reviews", href: "/topics/D9/", label: "综述", helper: "Reviews" },
  { key: "method", href: "/about/", label: "方法", helper: "Method" },
];

export function PhotonBriefHeader({ active }: PhotonBriefHeaderProps) {
  return (
    <header className="pb-site-header" data-pb-active={active || undefined}>
      <div className="pb-site-nav-shell">
        <a className="pb-site-brand" href="/" aria-label="PhotonBrief 首页">
          <span className="pb-site-brand-cn">光电前沿</span>
          <span className="pb-site-brand-en">PhotonBrief · LiGRP</span>
        </a>
        <button
          className="pb-nav-toggle"
          type="button"
          aria-label="打开 PhotonBrief 导航"
          aria-controls="pb-primary-nav"
          aria-expanded="false"
        >
          <span />
          <span />
          <span />
        </button>
        <nav className="pb-primary-nav" id="pb-primary-nav" aria-label="PhotonBrief 主导航">
          {items.map((item) => (
            <a
              href={item.href}
              key={item.key}
              aria-current={active === item.key ? "page" : undefined}
              data-pb-nav={item.key}
            >
              <span>{item.label}</span>
              <small>{item.helper}</small>
            </a>
          ))}
          <a className="pb-main-link" href="https://ligrp.net/">
            <span>李荣金课题组</span>
            <small>LiGRP</small>
          </a>
        </nav>
      </div>
    </header>
  );
}
